// extracted by css-extract-rspack-plugin
export default {"ConfirmationQuestion":"DisableAutoMerge-module__ConfirmationQuestion__q6Dl_"};